import React from "react";
import styled, { useTheme } from "styled-components";
import useAppTheme from "../hooks/useAppTheme";
import Switch from "react-switch";
import { BiSun, BiMoon } from "react-icons/bi";

export default function ThemeSwitch() {
  const { theme: currentTheme, toggleTheme } = useAppTheme();
  const theme = useTheme();

  return (
    <Container>
      <Switch
        height={24}
        width={48}
        onChange={toggleTheme}
        checked={currentTheme === "light"}
        onColor={theme.themeSwitchOnColor}
        offColor={theme.themeSwitchOffColor}
        activeBoxShadow={`0 0 2px 3px ${theme.themeSwitchBoxShadowColor}`}
        checkedIcon={
          <IconWrapper>
            <BiSun size={16} />
          </IconWrapper>
        }
        uncheckedIcon={
          <IconWrapper>
            <BiMoon size={16} />
          </IconWrapper>
        }
      />
    </Container>
  );
}

const Container = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled.div`
  height: 24px;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.primary};
`;
